module.exports = __webpack_public_path__ + "static/media/iot4.05ffa3f8.png";